export default __webpack_public_path__ + "static/media/v2_banner_bG.99394bb6.png";